import type {UserDetails} from 'src/types/referrer-portal';
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useSelector} from 'react-redux';
import {selectUserDetails} from 'src/selectors/referrer-portal';

import {
  SubTitleLarge,
  JumboLarge,
  JumboSmall,
  BodyMedium,
  Button,
  Avatar,
} from '@spaced-out/ui-design-system/lib/components/index';
import css from 'src/components/referrer-portal/user-form/form-container.css';


const UserCard = () => {
  const account: UserDetails | null | undefined =
    useSelector(selectUserDetails);
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;
  const {
    name,
    title = '',
    company_name,
    // @ts-expect-error - TS2339 - Property 'profile_picture' does not exist on type 'UserDetails'.
    profile_picture = '',
    location,
    bio,
  } = account || {};

  return (
    <div className={css.topContainer}>
      <div className={css.userCard}>
        {(profile_picture || name) && (
          <div className={css.profilePicContainer}>
            <Avatar
              size="extraLarge"
              classNames={{
                wrapper: css.profilePic,
              }}
              imageSrc={profile_picture}
              text={name}
            />
          </div>
        )}
        <div className={css.userDetailsCard}>
          {name && (
            <JumboLarge className={css.welcomeText}>
              {`${t('You_have_reached', 'You have reached')} `}
              {name}
              {`'${t('s_referral_link', 's referral link')}.`}
            </JumboLarge>
          )}

          <SubTitleLarge color="secondary">
            {`${title ?? ''}  ${company_name ? `@ ${company_name}` : ''} ${
              location ? `| ${location}` : ''
            }`}
          </SubTitleLarge>
          {bio && (
            <div>
              <BodyMedium className={css.bio}>{bio}</BodyMedium>
            </div>
          )}
        </div>
      </div>
      <Button classNames={{wrapper: css.rightSlot}}>
        <JumboSmall color="inversePrimary">
          {t('Submit_Your_Referral_Request', 'Submit Your Referral Request')}
        </JumboSmall>
      </Button>
    </div>
  );
};

export default UserCard;
